import { z } from 'zod'

export enum AppConfigView {
  Homepage = 'homepage',
  Navbar = 'navbar',
}

export const appConfigSearchParams = z.object({
  view: z.nativeEnum(AppConfigView).optional().catch(undefined),
})
